// src/components/Footer.js
import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2024 Documentation Site</p>
    </footer>
  );
}

export default Footer;
